<main>
    <section class="donate">
        <div class="content">
            <h2>
                <div class="cursive">become</div>
                <div>A Sponsor</div>
            </h2>

            <div class="sponsor-content">
                <img class="levels" src="../../assets/sponsorship-levels.png" alt="Sponsorship Levels" />

                <div class="iframe-placeholder">
                    <script src="https://donorbox.org/widget.js" paypalExpress="false"></script><iframe allowpaymentrequest="" frameborder="0" height="900px" name="donorbox" scrolling="no" seamless="seamless" src="https://donorbox.org/embed/parenting-with-purpose-event-sponsor" style="max-width: 420px; min-width: 250px; max-height:none!important" width="100%"></iframe>
                </div>
            </div>

            <div class="videos-row">
                <div class="video-container">
                    <iframe src="https://www.youtube.com/embed/Jzh0XJM-6Cc" title="YouTube video player" referrerpolicy="strict-origin-when-cross-origin" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
                <div class="video-container">
                    <iframe src="https://www.youtube.com/embed/nz0WOizgqsI" title="YouTube video player" referrerpolicy="strict-origin-when-cross-origin" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </section>
</main>
